// plugins/web-vitals.client.ts



import { sendVitals } from '~/utils/web-vitals'

export default defineNuxtPlugin(() => {
  const router = useRouter()
  router.afterEach(to => {
    sendVitals(to)
  })
})